/* eslint-disable jsx-a11y/alt-text */
import { Grid, Typography, Box } from '@material-ui/core';
import React from 'react';
import { currencyFormatter, simpleDateFormatter } from '../Shared/colorFormat';
import './index.css';

export class CustomerBalancePrint extends React.PureComponent<any, any> {
  renderItemHeaderTable = (isRTL: boolean, isCustomer: boolean) => {
    const custname = isRTL ? 'العميل' : 'Customer';
    const suppname = isRTL ? 'المورد' : 'Supplier';
    const name = isCustomer ? custname : suppname;
    return (
      <tr style={{ fontSize: 12 }}>
        <th>{name}</th>
        <th>{isRTL ? 'الهاتف' : 'Phone'}</th>
        <th>{isRTL ? 'رصيد اول الفترة' : 'Start Balance'}</th>
        <th>{isRTL ? 'رصيد الفترة' : 'Period Balance'}</th>
        <th>{isRTL ? 'رصيد اخر الفترة' : 'Total Balance'}</th>
      </tr>
    );
  };
  renderItemTable = (item: any, isRTL: any, isCustomer: boolean) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <td style={{ textAlign: 'center' }}>
          {isRTL
            ? isCustomer
              ? item?.customerNameAr
              : item?.supplierNameAr
            : isCustomer
            ? item?.customerName
            : item?.supplierName}
        </td>
        <td style={{ textAlign: 'center' }}>
          {isCustomer ? item?.customerPhone : item?.supplierPhone}
        </td>
        <td>{currencyFormatter({ value: item?.oldraseed })}</td>
        <td>{currencyFormatter({ value: item?.nowraseed })}</td>
        <td>{currencyFormatter({ value: item?.allraseed })}</td>
      </tr>
    );
  };

  renderHeader = (company: any) => (
    <img
      src={company?.header}
      alt={company?.name}
      height="auto"
      width="100%"
      style={{
        objectFit: 'contain',
      }}
    />
  );

  renderFooter = (company: any) => (
    <img
      src={company?.footer}
      alt={company?.name}
      height="100%"
      width="100%"
      style={{ objectFit: 'contain' }}
    />
  );

  renderFrontTop = ({ start, end, title }: any) => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ marginTop: 20 }}></Grid>
        <Grid item xs={12}>
          <Typography style={{ fontSize: 20, fontWeight: 'bold' }}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography>التاريخ:</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography>{simpleDateFormatter(new Date())}</Typography>
        </Grid>
        <Grid item xs={8}></Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16 }}>مدة التقرير:</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>
            {simpleDateFormatter(start)}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>
            {simpleDateFormatter(end)}
          </Typography>
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    );
  };

  render() {
    const { company, data, isRTL, start, end } = this.props;
    const { title, customers, suppliers } = data;
    let items;
    if (customers) {
      items = customers;
    } else {
      items = suppliers;
    }
    const isCustomer = customers ? true : false;
    return (
      <Box>
        <div className="header">{this.renderHeader(company)}</div>
        <Box
          style={{
            height: 170,
          }}
        ></Box>
        <div style={{ paddingLeft: 60, paddingRight: 40, direction: 'rtl' }}>
          <Box
            style={{
              height: 170,
              position: 'absolute',
              top: 170,
              width: '100%',
            }}
          >
            {this.renderFrontTop({ start, end, title })}
          </Box>
          <table id="report" className="report-container">
            <thead className="report-header">
              <div className="header-space"></div>
              {this.renderItemHeaderTable(isRTL, isCustomer)}
            </thead>
            <tbody className="report-content">
              {items?.map((item: any) =>
                this.renderItemTable(item, isRTL, isCustomer)
              )}
            </tbody>
            <tfoot className="report-footer">
              <tr style={{ padding: 0, borderColor: '#fff', borderWidth: 0 }}>
                <td style={{ padding: 0, borderColor: '#fff', borderWidth: 0 }}>
                  <div className="footer-info">
                    <div
                      className="page-footer"
                      style={{ fontSize: 14, padding: 5 }}
                    >
                      {company?.name}
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
            {/* <div style={{ marginTop: 100 }}>After Footer</div> */}
          </table>
        </div>
        <img alt={company?.name} src={company?.logo} className={'watermark'} />
      </Box>
    );
  }
}
